import React from 'react';
import { ArrowDownIcon, CheckIcon, XIcon } from 'lucide-react';
import { Section } from './Section';
import { afterItems, beforeItems } from '../data/workflow';
export function BeforeAfter() {
  return <Section tone="canvas" title="The clinical workflow transformation" subtitle="From scattered references to a structured approach to obesity care." cta="I want a more structured clinical workflow" ctaNote="One-Time Payment of $27 USD · Instant Download · 7-Day Guarantee" data-id="element-39" data-mp="3ogj6zexei0ex">
      <div className="grid items-stretch gap-4 md:grid-cols-2 md:gap-6" data-id="element-40" data-mp="3jhq1o9s9pfpu">
        <div className="rounded-3xl border-2 border-alarm/25 bg-white p-6 sm:p-8" data-id="element-41" data-mp="34saf75zrrwfy">
          <span className="inline-block rounded-full bg-alarm px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-42" data-mp="39qv8elgltfuw">
            Before
          </span>
          <p className="mt-4 text-lg font-bold text-ink" data-id="element-43" data-mp="2vt6xa5cc9n31">You may recognize some of these situations:</p>
          <ul className="mt-5 space-y-4" data-id="element-44" data-mp="30s9oomzebusj">
            {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-45" data-mp="x2qvjglq55wp">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alarm/10 text-alarm" data-id="element-46" data-mp="t3i4iji2jm4u">
                  <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-47" data-mp="171ex74tej8e8" />
                </span>
                <span className="text-[16px] leading-relaxed text-muted" data-id="element-48" data-mp="1246hdavq7gg5">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="flex justify-center md:hidden" aria-hidden="true" data-id="element-49" data-mp="9f9ae3wyt62p">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-white shadow-card" data-id="element-50" data-mp="9cwlf6sshvg5">
            <ArrowDownIcon className="h-5 w-5" data-id="element-51" data-mp="jd5l4ulzpz0a" />
          </span>
        </div>

        <div className="rounded-3xl border-2 border-cta bg-white p-6 shadow-card sm:p-8" data-id="element-52" data-mp="jb2kzhr4iphu">
          <span className="inline-block rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-53" data-mp="3rr4gbu151gcq">
            After
          </span>
          <p className="mt-4 text-lg font-bold text-ink" data-id="element-54" data-mp="1qpofu5vk4tlj">With Obesity Clinical Blueprint™ you'll be able to:</p>
          <ul className="mt-5 space-y-4" data-id="element-55" data-mp="1voj3pm8dt8ci">
            {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-56" data-mp="20hls7fyaxrlu">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-57" data-mp="20iwwrhzkn3e0">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-58" data-mp="17serqbfaerxy" />
                </span>
                <span className="text-[16px] font-medium leading-relaxed text-ink" data-id="element-59" data-mp="1cq6l79vkym49">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-60" data-mp="1lrmv7gihgm7y">
        The goal isn't to replace your clinical judgment.{' '}
        <strong className="text-ink" data-id="element-61" data-mp="2s6xbou9sajcu">It's to give your existing knowledge a clearer structure.</strong>
      </p>
    </Section>;
}